import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fe60ce9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main" }

import ShoppingCart from "@/components/layouts/ShoppingCart.vue";
import ProductDialog from "@/components/common/ProductDialog.vue";
import NavigationBar from "@/components/layouts/NavigationBar.vue";
import BottomNavigationBar from "@/components/layouts/BottomNavigationBar.vue";

import router from "@/router";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cart = ref(false);
const cartBackdrop = ref(true);

const toggleCart = () => {
  cart.value = !cart.value;
  cartBackdrop.value = !cartBackdrop.value;
};

const toggleRoute = (path: string) => {
  toggleBackdrop();
  router.push(path);
};

const toggleBackdrop = () => {
  if (cart.value) {
    cart.value = !cart.value;
    cartBackdrop.value = !cartBackdrop.value;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(NavigationBar, {
      onToggleCart: toggleCart,
      onToggleRoute: _cache[0] || (_cache[0] = path => toggleRoute(path))
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _createVNode(ShoppingCart, {
      cart: cart.value,
      "cart-backdrop": cartBackdrop.value,
      onToggleBackdrop: toggleBackdrop,
      onCheckout: _cache[1] || (_cache[1] = ($event: any) => (toggleRoute('/checkout')))
    }, null, 8, ["cart", "cart-backdrop"]),
    _createVNode(ProductDialog),
    _createVNode(BottomNavigationBar, {
      onToggleCart: toggleCart,
      onToggleRoute: _cache[2] || (_cache[2] = path => toggleRoute(path))
    })
  ]))
}
}

})